import { FormPartialDataUsPersonInfo } from "../../components/FormPartialUsPersonInfo";
import { CertifyTaxPayerInfo } from "../../steps/CertifyTaxPayerInfo";
import { OnboardingStep } from "../../types";
import { StepUsPersonInfoForm } from "./steps/StepUsPersonInfoForm";

export type FormDataUsPersonInfo = {
  isUsPerson: boolean;
  usPersonInfo: FormPartialDataUsPersonInfo;
};

export type FlowUsPersonInfoContext = {
  usPersonInfo?: FormDataUsPersonInfo;
};

export function getUsPersonInfoSteps(
  context: FlowUsPersonInfoContext
): OnboardingStep[] {
  return [
    {
      title: "Update taxpayer info",
      slug: "update",
      component: StepUsPersonInfoForm
    },
    {
      title: "Certify taxpayer info",
      slug: "certify",
      component: CertifyTaxPayerInfo
    }
  ];
}
